export default "/images/widget.svg?f2eac7baecb8f06f7f0fad2d792d1dac";